<template>
<div class="page">
    <div class="m-b-24 bg-content padding15">
      <el-form size="small" label-width="80px">
        <el-row :gutter="12">
          <el-col :span="6">
            <el-switch
              v-model="enable"
              active-color="#f6ac19"
              inactive-color="#282828"
              @change="updateShowStatus">
            </el-switch>
            &nbsp;<span>启用白名单功能</span>
          </el-col>
          <el-col :span="16">
            <div class="text right">
              <el-button type="primary" size="small" plain @click="addTab = true">添加</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="padding15">
        <el-table
          :data="list"
          size="small"
          :row-style="{cursor: 'pointer'}"
          style="width: 100%">
          <el-table-column
            prop="modificationIp"
            label="IP"
            width="313">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="添加时间"
            width="313">
          </el-table-column>
          <el-table-column
            prop="createUserName"
            label="添加人"
            width="313">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            width="313">
            <template slot-scope="scope">
            <span v-if="scope.row.status == true">生效</span>
            <span v-else>失效</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="id"
            label="操作"
            width="313">
            <template slot-scope="scope">
              <el-button type="text" @click="addServer(scope.row.id, scope.row.status, scope.row.modificationIp)" size="small"><i class="el-icon-edit-outline"></i></el-button>
              <el-button type="text" @click="delServer(scope.row.id)" size="small"><i class="el-icon-delete"></i></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="text center margin15-tb">
          <el-pagination
            background
            layout="prev, pager, next, sizes, total"
            :total="totalRecords"
            :page-size="searchReq.limit"
            :current-page="searchReq.page"
            @current-change="currentChange"
            @size-change="sizeChange">
          </el-pagination>
        </div>
    </div>
    <div class="dialog">
      <el-dialog
        title="添加白名单"
        :visible.sync="addTab"
        width="50%"
        center>
        <el-form label-width="160px">
          <span>IP地址：启用后限定以下ip地址访问平台</span>
          <el-input type="textarea" :rows="6" v-model="ips" style="width: 100%;"></el-input>
          <span style="color: red">加入IP地址或IP地址的范围，支持使用-作为范围的间隔符号，或是*代表0-255，请以回车键（Enter）作为分隔添加多个IP。</span>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addIpsSubmit" size="small">保存</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="修改"
        :visible.sync="singleIpEditModal"
        width="40%"
        center>
        <el-form label-width="140px">
          <el-form-item label="IP地址：">
            <el-input v-model="singleIp" style="width: 70%"></el-input>
          </el-form-item>
          <el-form-item label="生效状态：">
            <el-switch
              v-model="singleIpStatus">
            </el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updateSingleIpEdit" size="small">保存</el-button>
        </div>
      </el-dialog>
    </div>
</div>
</template>
<script>
export default {
  props: [
    'companyIdTemp'
  ],
  data() {
    return {
      value1: true,
      enable: false,
      list: [],
      totalRecords: 0,
      searchReq: {
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      },
      companyId: '',
      addTab: false,
      singleIpEditModal: false,
      ips: '',
      singleIp: '',
      singleIpStatus: false,
      id: '',
      err: null
    };
  },
  watch: {
    companyIdTemp(companyId) {
      this.companyId = companyId;
      const req = this.searchReq;
      req.companyId = companyId;
      this.$ajax({
        url: '/company/getCompanyIpList',
        data: req
      }).then((res) => {
        console.warn('白名单');
        console.warn(res);
        this.list = res.data.list;
        this.searchReq.totalRecords = res.data.totalRecords;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
      this.$ajax({
        url: '/company/getIpRange',
        params: { company: companyId }
      }).then((res) => {
        console.warn(res);
        if (res.data !== null) {
          this.enable = res.data.showStatus;
        } else {
          this.enable = false;
        }
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    }
  },
  // 进入页面调用此方法
  mounted() {},
  methods: {
    fetch() {},
    currentChange(page) {
      this.searchReq.page = page;
      this.roleList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.getCompanyIpList();
    },
    getCompanyIpList() {
      const req = this.searchReq;
      req.companyId = this.companyId;
      this.$ajax({
        url: '/company/getCompanyIpList',
        data: req
      }).then((res) => {
        console.warn(res);
        this.list = res.data.list;
        this.searchReq.totalRecords = res.data.totalRecords;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    // 编辑
    addServer(id, status, modificationIp) {
      this.singleIpEditModal = true; // 开启弹窗
      this.singleIp = modificationIp;
      this.singleIpStatus = status;
      this.id = id;
    },
    // 修改
    updateSingleIpEdit() {
      const singleIpStatus = this.singleIpStatus;
      const singleIp = this.singleIp;
      console.warn(`${singleIpStatus}------${singleIp}--------${this.id}`);
      const req = {
        id: this.id,
        modificationIp: singleIp,
        status: singleIpStatus,
        companyId: this.companyId
      };
      this.$ajax({
        prompt: true,
        url: '/company/updateSingleIpEdit',
        data: req
      }).then((res) => {
        console.warn(res);
        if (res.data !== '' && res.data !== null) {
          this.$message({
            type: 'info',
            message: res.data
          });
          this.enable = false;
        }
        this.singleIpEditModal = false;
        this.getCompanyIpList();
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    // 删除
    delServer(id) {
      console.warn(id);
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          url: '/company/deleteSingleIpEdit',
          params: { ipRangId: id }
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getCompanyIpList();
        }).catch((error) => {
          this.$message({
            type: 'error',
            message: error.message
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 添加IP
    addIpsSubmit() {
      const ips = this.ips;
      const split = ips.split('\n');
      split.forEach((ipss, i) => {
        console.warn(i);
        i++;
        this.$ajax({
          url: '/company/ipCheck',
          data: { ip: ipss }
        }).then((res) => {
          console.warn(res);
        }).catch((error) => {
          this.err = error;
          this.$message({
            type: 'error',
            message: `第${i}个${error.message}`
          });
        });
      });
      console.warn(this.err);
      if (this.err === null) {
        console.warn('1111');
        // 校验成功
        this.$ajax({
          prompt: true,
          url: '/company/addIps',
          params: { ips: split.toString(), showStatus: true, companyId: this.companyId }
        }).then((res) => {
          console.warn(res);
          this.addTab = false;
          this.getCompanyIpList();
        }).catch((error) => {
          this.err = null;
          this.$message({
            type: 'error',
            message: error.message
          });
        });
      }
    },
    // 开关
    updateShowStatus() {
      const enable = this.enable;
      console.warn(enable);
      this.$ajax({
        prompt: true,
        url: '/company/updateShowStatus',
        params: { showStatus: enable, companyId: this.companyId }
      }).then((res) => {
        console.warn(res);
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
        if (enable) {
          this.enable = false;
        } else {
          this.enable = true;
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/company/ip_info.vue